import React from "react";
import {IoCloseOutline} from "react-icons/io5";
import EventEmitter from "../../../utils/EventEmitter";
import OpenSensorStatusModal from "./OpenSensorStatus";

interface Props {}
interface State {
   isModalOpen: boolean;
}


export default class Header extends React.Component<Props, State> {
  // modalRef = React.createRef<OpenSensorStatusModal>();
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  emitter = EventEmitter.getInstance();

  closeModal = () => {
    this.emitter.emit('onClickPeopleCrowdedMarker', {item: undefined});
  }

  openSensorStatus = () => {
     this.setState({ isModalOpen: true });
  }
  closeSensorStatus = () => {
    this.setState({ isModalOpen: false });
  }

  render() {
    return (
      <div className={"header"}>
        <div className={"row"}>
          <div/>
          <IoCloseOutline color={"#FFFFFF"} size={30} className={"cursor"} onClick={this.closeModal}/>
        </div>
        <div style={{height: 7}} />
        <div className={"row"} style={{alignItems: "flex-end"}}>
          <div className={"txt title"}>실시간 유동 인구 전체 현황</div>
          {/* 1. ToDo : 센서 현황 창이 떠야함 */}
          <div className={"txt current-state--btn"} style={{}} onClick={this.openSensorStatus}>
            센서 현황 <span style={{color:"#FF0000", marginLeft: 5}}>●</span>
          </div>
        </div>
        {this.state.isModalOpen && (
          <OpenSensorStatusModal closeSensorStatus={this.closeSensorStatus} />
        )}
      </div>
    );
  }
}
